
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"9","height":"10","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.898 9.952h3.569c2.085 0 3.404-1.1 3.404-2.789 0-1.333-.957-2.297-2.351-2.372v-.055c1.134-.157 1.907-1.011 1.907-2.098 0-1.525-1.162-2.461-3.063-2.461H1.898C1.167.177.743.607.743 1.359v7.417c0 .745.424 1.176 1.155 1.176zM3 4.237V1.783h1.682c.957 0 1.524.438 1.524 1.19 0 .793-.629 1.264-1.695 1.264H2.999zm0 4.136V5.659h1.716c1.203 0 1.866.465 1.866 1.34 0 .896-.643 1.374-1.818 1.374H2.999z","fill":"#000"}})])
          )
        }
      }
    